/* eslint-disable no-console */
//console.log( 'Hello World! (from exe-contact-us-form-block block)' );
/* eslint-enable no-console */
document.addEventListener('DOMContentLoaded', function () {
    var submitButtons = document.getElementsByClassName("wp-exe-contact-form-submit-button");
    var submitButton = submitButtons[0];
    submitButton.addEventListener("click",function() {
		var fullName = document.getElementsByName("full_name")[0].value;
		var email = document.getElementsByName("email")[0].value;
		var text = document.getElementsByName("text")[0].value;
		
		async function sendMail(url, data){
			
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			})
			
			if(!response.ok){
				const error = (data && data.message) || response.status;
				return error;
			}
			
			return response.json();
		}
		
		function markInvalidElement(element){
			element.classList.add("invalid");
			setTimeout(function () {resetElementClass(element)}, 1000);
			function resetElementClass(element){
				element.classList.remove("invalid");
			}
		}
		
		function isValid(fullName, email, text){
			var result = {
				all_valid: true,
				name_valid: true,
				email_valid: true,
				text_valid:true
			};
			
			if(!fullName){
				result.name_valid = false;
				result.all_valid = false;
			}
			emRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if(!emRegex.test(email)){
				result.email_valid = false;
				result.all_valid = false;
			}
			if(!text){
				result.text_valid = false;
				result.all_valid = false;
			}
			
			return result;
		}
		
		var valid = isValid(fullName, email, text);
		if(valid.all_valid){
			sendMail("/wp-admin/admin-ajax.php?action=send_mail&nonce="+contactNonce, {full_name: fullName, email: email, text: text}).then((data) => {
				console.log(data);
				if(typeof data === 'object'){
					if(data.mail_sent == true){
						playSuccessMessage();
					}else{
						if(!data.valid.name){
							markInvalidElement(document.getElementsByName("full_name")[0]);
						}
						if(!data.valid.email){
							markInvalidElement(document.getElementsByName("email")[0]);
						}
						if(!data.valid.text){
							markInvalidElement(document.getElementsByName("text")[0]);
						}
					}
				}else{
					alert("Error, server status code: "+data);
				}
			});
		}else{
			if(!valid.name_valid){
				markInvalidElement(document.getElementsByName("full_name")[0]);
			}
			if(!valid.email_valid){
				markInvalidElement(document.getElementsByName("email")[0]);
			}
			if(!valid.text_valid){
				markInvalidElement(document.getElementsByName("text")[0]);
			}
		}
    });

	
    var inquiryTextarea = document.getElementsByName("text")[0];
    inquiryTextarea.addEventListener("input", function(){
		const lineHeight = getLineHeight(inquiryTextarea);
		inquiryTextarea.style.height = 'auto';
		inquiryTextarea.style.height = lineHeight + 'px';
    });
});

function clearFields(){
	document.getElementsByName("full_name")[0].value = "";
	document.getElementsByName("email")[0].value = "";
	document.getElementsByName("text")[0].value = "";
}

function playSuccessMessage(){
	document.getElementsByClassName("exe-success-mail-message-block")[0].classList.remove("hidden");
	/*
	setTimeout(fadeOutMessage, 1500);
	function fadeOutMessage(){
		clearFields();
		document.getElementsByClassName("exe-success-mail-message-block")[0].classList.add("faded");
		setTimeout(resetMessage, 500);
	}
	function resetMessage(){
		document.getElementsByClassName("exe-success-mail-message-block")[0].classList.remove("faded");
		document.getElementsByClassName("exe-success-mail-message-block")[0].classList.add("hidden");
	}
	*/
}

function getLineHeight(element) {
	if(element.value == ""){
		return 'unset';
	}
	
	var textVal = document.getElementsByName("text")[0].value;
	if(textVal[textVal.length - 1] == '\n' && textVal[textVal.length - 2] == '\r' || textVal[textVal.length - 1] == '\n'){
		textVal += " ";
	}
	
	const tempElement = document.createElement('pre');
	tempElement.innerHTML = textVal;
	tempElement.style.width = getComputedStyle(element).width;
	tempElement.style.fontFamily = getComputedStyle(element).fontFamily;
	tempElement.style.fontSize = getComputedStyle(element).fontSize;
	tempElement.style.lineHeight = getComputedStyle(element).lineHeight;
	tempElement.style.wordWrap = getComputedStyle(element).wordWrap;
	tempElement.style.whiteSpace = getComputedStyle(element).whiteSpace;
	tempElement.style.visibility = 'hidden';
	document.body.appendChild(tempElement);
	
	

	const height = tempElement.clientHeight;

	document.body.removeChild(tempElement);
	
	return height;
}